module.exports = __webpack_public_path__ + "static/img/product_banner_22_zh.09c2197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_22_zh.png
// module id = Q2Ry
// module chunks = 34